import React, { useState } from 'react';
import { ETowerOption } from '../../../../../store/ducks/contracts-and-constructions/types';
import { Button, RadioButton, TextField } from '@gerdau/hefesto';
import { Chips } from '@gerdau/hefesto-mais-web';
import { TowerNameInput, TowerSelectContainer } from './styles';
interface ITowerSelectorProps {
  towers: string[];
  towerOption: ETowerOption;
  onUpdateTowerSelector: (towerOption: ETowerOption, towers: string[]) => void;
}

const TowerSelector: React.FC<ITowerSelectorProps> = ({
  towers,
  towerOption,
  onUpdateTowerSelector
}) => {
  const [towerName, setTowerName] = useState('');

  const removeTower = (newTowers: string[]) => {
    if (newTowers.length === 0) {
      onUpdateTowerSelector(ETowerOption.UNIQUE, newTowers);
    }
    onUpdateTowerSelector(towerOption, newTowers);
  };

  const addTower = (option: ETowerOption) => {
    onUpdateTowerSelector(option, [...towers, towerName]);
    setTowerName('');
  };

  const onChangeTowerOption = (newTowerOption: ETowerOption) => {
    if (newTowerOption !== towerOption) {
      const newTowers: string[] = [];
      onUpdateTowerSelector(newTowerOption, newTowers);
    }
  };

  return (
    <>
      <RadioButton
        label={'Único'}
        id={'unique'}
        name={'unique'}
        checked={towerOption === ETowerOption.UNIQUE}
        onChange={() => onChangeTowerOption(ETowerOption.UNIQUE)}
        value={ETowerOption.UNIQUE.toString()}
      />
      <RadioButton
        label={'Números ou letras'}
        id={'numberOrLettersRadio'}
        name={'numberOrLetters'}
        checked={towerOption === ETowerOption.NUMBERS_OR_LETTERS}
        onChange={() => onChangeTowerOption(ETowerOption.NUMBERS_OR_LETTERS)}
        value={ETowerOption.NUMBERS_OR_LETTERS.toString()}
      />
      {towerOption !== ETowerOption.UNIQUE && (
        <TowerSelectContainer>
          <span>Adicione as torres:</span>
          <TowerNameInput>
            <TextField
              label={'Nome da torre'}
              name={'towerName'}
              value={towerName}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setTowerName(e.target.value)
              }
            />
            <Button
              name={'addTower'}
              onClick={() => addTower(towerOption)}
              disabled={towerName.length < 1}
            >
              Adicionar
            </Button>
          </TowerNameInput>
          <div>
            <Chips
              type={'input'}
              updateChips={(e) => removeTower(e.map((tower) => tower.label))}
              chips={towers.map((tower, idx) => {
                return {
                  label: tower,
                  id: idx.toString()
                };
              })}
            />
          </div>
        </TowerSelectContainer>
      )}
    </>
  );
};

export default TowerSelector;
